import { render, staticRenderFns } from "./SuccessCheck.vue?vue&type=template&id=31f1b2b8&scoped=true&"
import script from "./SuccessCheck.vue?vue&type=script&lang=js&"
export * from "./SuccessCheck.vue?vue&type=script&lang=js&"
import style0 from "./SuccessCheck.vue?vue&type=style&index=0&id=31f1b2b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f1b2b8",
  null
  
)

export default component.exports